////////////////////////////////////////////////////////////////// GLOBAL VUE PLUGINS
import FancyBox from './plugins/fancy-box/fancybox'
Vue.use(FancyBox)

////////////////////////////////////////////////////////////////// GLOBAL VUE COMPONENTS
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('BgImage', BgImage)

////////////////////////////////////////////////////////////////// APP
import SideMenu from './components/side-menu/side-menu.vue'
import {
    disableBodyScroll,
    enableBodyScroll
} from 'body-scroll-lock';

import {
    inlineOptions,
    galleryOptions
} from './imports/fancyOptions'

var app = new Vue({
    el: '#app',
    components: {
        SideMenu
    },
    data() {
        return {
            pageScrolled: false,
            sideMenuOpen: false,
            scrollDisabled: false,
            // fancyboxInlineOpts: inlineOptions,
            // fancyboxGalleryOpts: galleryOptions,
        }
    },
    methods: {
        selectCategory(href){
            window.location.href = href;
        },
        onScroll() {
            this.pageScrolled = window.pageYOffset > 0;
        },
        toggleScroll() {
            this.fixScrollbarShifting();
            if (this.scrollDisabled) {
                document.querySelector("body").classList.add("fancybox-active", "compensate-for-scrollbar");
            } else {
                document.querySelector("body").classList.remove("fancybox-active", "compensate-for-scrollbar");
            }
        },
        toggleSideMenu() {
            if (!this.sideMenuOpen) {
                disableBodyScroll(this.scrollElement, {
                    paddingRightElements: [document.body, document.querySelector(".header")],
                    reserveScrollBarGap: true,
                });
            } else {
                enableBodyScroll(this.scrollElement, {
                    reserveScrollBarGap: true
                });
            }
            this.sideMenuOpen = !this.sideMenuOpen;
        },
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0;
        window.addEventListener('scroll', this.onScroll, {
            passive: true
        });
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    }
})


// WEBPACK FOOTER //
// ./src/js/app.js